<template>
    <div></div>
</template>

<script>
import { getSavedLocale } from "../util/locate"

export default {
    name: "Login",
    methods: {
        startLogin: function() {
            this.$store.dispatch("isSignIn", true)
            this.$router.push({
                name: "Dashboard",
                params: { lang: getSavedLocale() }
            })
        }
    },
    mounted() {
        this.startLogin()
    }
}
</script>

<style scoped></style>
